import { FC } from 'react';

import { isEmptyString } from '@core/Utils/Strings/EmptyString';
import { Grid } from '@gds/Grid/Grid';
import { Typography } from '@gds/Typography/Typography';

import { checkHasCta } from '@page-builder/Utils/HasCta';
import cn from 'classnames';

import Cta from './Cta';

import styles from './FloatingCta.module.css';

type Props = {
  cmsData: any;
};

const FloatingCta: FC<Props> = ({ cmsData }) => {
  const bylineText = cmsData.elements.fctasbyline.value;
  const shouldShowCopy = !isEmptyString(bylineText);
  const shouldShowCtaBlock = checkHasCta(cmsData) ? true : false;
  return (
    <Grid.Container
      className={cn(styles.floatingCta, 'blogCmpnt', { [styles.noCopy]: !shouldShowCopy })}
    >
      <Grid.Row>
        <Grid.Col
          className={styles.content}
          width={{
            mobile: 12,
            tablet: 12,
            desktop: 12,
          }}
        >
          {shouldShowCopy && (
            <Typography variant="body1" className={styles.byline}>
              {bylineText}
            </Typography>
          )}

          {shouldShowCtaBlock && (
            <div className={styles.ctaBlock}>
              {cmsData.elements.cta.linkedItems
                .slice(0, 2)
                .reverse()
                .map((ctaData: any, index: number) => (
                  <Cta
                    className={styles.ctaButton}
                    ctaData={ctaData}
                    fullWidth
                    key={ctaData.system.id}
                    variant={index % 2 ? 'outlined' : undefined}
                  />
                ))}
            </div>
          )}
        </Grid.Col>
      </Grid.Row>
    </Grid.Container>
  );
};

export default FloatingCta;
